// extracted by mini-css-extract-plugin
export default {"text":"components__text--2p4","submit":"components__submit--D5Z","skip":"components__skip--Gw6"};